<template>
  <div class="index_sign">
    <div class="index_sign_head">
      剩余问答次数: {{counts}}
    </div>
    <div class="index_sign_body div_shadow">
      <div class="index_sign_body_one" v-for="item in weeks" :key="item.week">
        <div class="index_sign_body_left">
          <div class="index_sign_body_left_top">
            {{item.title}}
          </div>
          <div class="index_sign_body_left_bottom">
            {{item.description}}
          </div>
        </div>
        <div class="index_sign_body_right">
          <el-button type="info" disabled round plain v-if="signed.indexOf(item.week)===-1 && week > item.week">未签到</el-button>
          <el-button type="primary" disabled round plain v-if="signed.indexOf(item.week)>=0">已签到</el-button>
          <el-button type="primary" round v-if="signed.indexOf(item.week)===-1 && week === item.week" @click="sign">立即签到</el-button>
          <el-button type="info" disabled round plain v-if="signed.indexOf(item.week)===-1 && week < item.week">待签到</el-button>
        </div>
      </div>
      <div class="index_sign_body_one">
        <div class="index_sign_body_left">
          <div class="index_sign_body_left_center">
            {{setting.title}}
          </div>
        </div>
        <div class="index_sign_body_right">
          <el-button type="info" disabled round plain v-if="signed.length<7">未获得</el-button>
          <el-button type="primary" disabled round v-if="signed.length===7">已获得</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { userSignIn,userSignConfig,getOrderSum } from "../../api/api";
  import { getJsonStorage,setJsonStorage } from "../../util/storage";

    export default {
      name: "sign",
      data() {
        return {
          counts:0,
          setting:{},
          weeks:[],
          signed:[],
          week:0,
          interval:null,
          user:getJsonStorage("openai_user")
        }
      },
      mounted(){
        this.getSum();
        this.getConfig();
        if(this.interval==null){
          this.interval = setInterval(()=>{
            this.getWeek();
          },1000);
        }
      },
      methods:{
        getWeek(){
          let week = new Date().getDay();
          this.week = (week === 0 ? 6 : week - 1);
        },
        getSum(){
          getOrderSum().then(res => {
            if(res && res.status === 0 && res.data!=null){
              for(let r in res.data){
                if(res.data[r]['uri'] === '/datacenter/standard/gemini/v1/conversation,'){
                  this.counts = res.data[r]['counts'] - res.data[r]['used'];
                  break;
                }
              }
            }
          });
        },
        getConfig(){
          userSignConfig().then(res => {
            if(res && res.status === 0){
              this.setting = res.data.setting;
              this.weeks = res.data.setting.weeks;
              this.weeks.sort((a,b)=>{return a.week - b.week;});
              this.signed = res.data.signed;
            }
          })
        },
        sign(){
          userSignIn().then(res => {
            if(res && res.status === 0){
              this.getConfig();
              this.getSum();
            }
          })
        }
      }
    }
</script>

<style scoped>
  .index_sign {
    position:absolute;
    top:6vh;
    left:0;
    width: 100%;
    height: 94vh;
    background-color: #f7f7f7;
    text-shadow: .3px .3px .3px grey;
  }
  .index_sign_head {
    width:90%;
    margin:1vh 5%;
    height:3vh;
    line-height:3vh;
    font-size:1rem;
    float:left;
    font-weight:100;
  }
  .index_sign_body {
    width:90%;
    margin:1vh 5%;
    height:86vh;
    float:left;
  }
  .div_shadow {
    background-color:#f9f9f9;
    border-radius:.3rem;
    -webkit-box-shadow: -1px -1px 1px 1px #eee;
    -moz-box-shadow: -1px -1px 1px 1px #eee;
    box-shadow: -1px -1px 1px 1px #eee;
  }
  .index_sign_body_one {
    height:10vh;
    width:100%;
    margin:0 auto;
    float:left;
    border-bottom: .2vh solid #eee;
  }
  .index_sign_body_left {
    width:70%;
    height:10vh;
    float:left;
  }
  .index_sign_body_right {
    width:30%;
    height:10vh;
    line-height:10vh;
    float:left;
    text-align:center;
  }
  .index_sign_body_left_top {
    width:100%;
    height:5vh;
    line-height:6vh;
    float:left;
    text-indent: 1rem;
    letter-spacing: .1rem;
    font-weight:200;
  }
  .index_sign_body_left_bottom {
    width:100%;
    height:5vh;
    line-height:3vh;
    float:left;
    text-indent: 1rem;
    font-size:.85rem;
    color:grey;
    letter-spacing: .1rem;
    font-weight:200;
  }
  .index_sign_body_left_center {
    width:100%;
    height:10vh;
    line-height:10vh;
    float:left;
    text-indent: 1rem;
    font-size:.85rem;
    color:grey;
    letter-spacing: .1rem;
    font-weight:200;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/sign.vue